// extracted by mini-css-extract-plugin
export default {"toggleControl":"styles_toggleControl__gLhnX"};